import { render } from "./StudentReport.vue?vue&type=template&id=4a855ed7&scoped=true"
import script from "./StudentReport.vue?vue&type=script&lang=js"
export * from "./StudentReport.vue?vue&type=script&lang=js"

import "./StudentReport.vue?vue&type=style&index=0&id=4a855ed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a855ed7"]])

export default __exports__